//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../../axios/axios.js'
import { mapGetters } from 'vuex'
import { setPreciseAmount } from './ReportMaterialsHelperFunctions.js'
import { createFieldConfig, Store } from '../../../components/QSelectUtils.js'
import ItemsSearchField from '../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    ItemsSearchField
  },
  props: {
    record: {
      type: Object,
      default: null
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    operation: {
      type: String,
      default: null
    },
    // ====================
    serviceObjectDefault: {
      type: Object,
      default () {
        return {}
      }
    },
    isGeneralDemounting: {
      type: Boolean,
      default: false
    },
    materialesAvailable: {
      type: Array,
      default () {
        return []
      }
    },
    consumptions: {
      type: Array,
      default () {
        return []
      }
    },
    mountings: {
      type: Array,
      default () {
        return []
      }
    },
    demountings: {
      type: Array,
      default () {
        return []
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    projects: {
      type: Array,
      default () {
        return []
      }
    },
    tags: {
      type: Array,
      default () {
        return []
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      demounting: null,

      stocksOptions: [],
      defaultStockKey: null,
      defaultStockName: null,

      editedMaterial: null,
      toolFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getTools,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 1
      })),

      editedNomenclature: null,
      nomenclatureFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getNomenclatures,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 1
      })),

      serviceObject: null,
      serviceObjectFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getServiceObjects,
        searchable: true,
        searchFiltrationBySource: true,
        searchValueMinLength: 1
      })),

      brigades: [],

      units: [
        'шт',
        'упак',
        'пар',
        'компл',
        'м',
        'кг',
        'бут',
        'лист',
        'л',
        'м2',
        'м3',
        'рул',
        'мешок',
        'т',
        'гКал'
      ],
      setPreciseAmount: setPreciseAmount,

      optionsConsumptionDf: [
        {
          label: 'Да',
          value: true
        },
        {
          label: 'Нет',
          value: false
        },
        {
          label: 'Не выбрано',
          value: null
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      stocks: 'getStocks'
    }),
    disabledButtonSave: function () {
      return !(this.reportActionsAccess.editMaterials &&
            (this.demounting.toolName && (this.demounting.toolName !== '' || this.demounting.toolName.trim().length > 0) &&
            (this.demounting.amount && this.demounting.amount !== '' && this.demounting.amount > 0) &&
            (this.demounting.unit && this.demounting.unit !== '') &&
            (this.isGeneralDemounting ? this.demounting.serviceObjectKey : true)) &&
            this.demounting.stockKey &&
            this.demounting.brigadeId)
    }
  },
  created: function () {
    this.prepareStocks()

    const demounting = {
      toolName: null,
      toolKey: null,
      amount: null,
      unit: null,
      nomName: null,
      nomKey: null,
      serviceObjectKey: null,
      serviceObjectName: null,
      recId: null,
      sn: null,
      tag: null,
      stockKey: null,
      stockName: null,
      brigadeId: null,
      brigadeName: null,
      reportPaths: null,
      reports: null,
      time: null
    }

    if (this.serviceObjectDefault != null) {
      this.serviceObject = {}
      this.serviceObject.id = this.serviceObjectDefault.key
      this.serviceObject.name = this.serviceObjectDefault.name
    }
    if (this.report.brigadeId && this.report.brigadeId !== undefined) {
      this.brigades = [{ brigadeId: this.report.brigadeId, brigadeName: this.report.brigadeName }, ...this.report.riBrigades]
    }

    if (this.isEdit) {
      this.demounting = demounting

      const editedDemounting = this.record
      this.demounting.toolName = editedDemounting.toolName
      this.demounting.toolKey = editedDemounting.toolKey
      this.demounting.amount = editedDemounting.amount
      this.demounting.unit = editedDemounting.unit
      this.demounting.nomName = editedDemounting.nomName
      this.demounting.nomKey = editedDemounting.nomKey
      this.demounting.serviceObjectName = editedDemounting.serviceObjectName
      this.demounting.serviceObjectKey = editedDemounting.serviceObjectKey
      this.demounting.noted = editedDemounting.noted
      this.demounting.note = editedDemounting.note
      this.demounting.recId = editedDemounting.recId
      this.demounting.sn = editedDemounting.sn
      this.demounting.tag = editedDemounting.tag
      this.demounting.stockKey = editedDemounting.stockKey
      this.demounting.stockName = editedDemounting.stockName
      this.demounting.brigadeId = editedDemounting.brigadeId
      this.demounting.brigadeName = editedDemounting.brigadeName
      this.demounting.reportPaths = editedDemounting.reportPaths
      this.demounting.reports = editedDemounting.reports
      this.demounting.time = editedDemounting.time

      this.editedNomenclature = {
        id: editedDemounting.nomKey,
        name: editedDemounting.nomName
      }
      this.editedMaterial = {
        id: editedDemounting.toolKey,
        name: editedDemounting.toolName
      }
    } else {
      this.demounting = demounting

      if (this.serviceObject && this.serviceObject.id && this.serviceObject.name) {
        this.demounting.serviceObjectKey = this.serviceObject.id
        this.demounting.serviceObjectName = this.serviceObject.name
      }
      if (this.report.brigadeId && this.report.brigadeId !== undefined) {
        this.demounting.brigadeId = this.report.brigadeId
        this.demounting.brigadeName = this.report.brigadeName
      }
      this.demounting.stockKey = this.defaultStockKey
      this.demounting.stockName = this.defaultStockName
      this.demounting.reports = this.report.key
    }
  },
  methods: {
    onAddDemounting: function (operation) {
      // TODO
    },
    onEditDemounting: function (row) {
      // TODO
    },
    getTools: function (text = '') {
      const urlName = '/service/delta/fastsearch/searchInTreeByPattern?tree=dictDemountedTools&limit=100&pattern=' + text
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          return (response.data && response.data.length) ? response.data : []
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка загрузки списка материалов',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка загрузки списка материалов'))
        }
      })
    },
    getNomenclatures: function (text = '') {
      const urlName = '/service/delta/fastsearch/searchInTreeByPattern?tree=dictTools&limit=100&pattern=' + text
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          return (response.data && response.data.length) ? response.data : []
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка получения расходов вне склада',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка получения расходов вне склада'))
        }
      })
    },
    onSetTool: function (tool) {
      if (tool) {
        this.demounting.toolKey = tool.id
        this.demounting.toolName = tool.name
      } else {
        this.demounting.toolKey = null
        this.demounting.toolName = null
      }
    },
    onSetNomenclature: function (nomenclature) {
      if (nomenclature) {
        this.demounting.nomKey = nomenclature.id
        this.demounting.nomName = nomenclature.name
      } else {
        this.demounting.nomKey = null
        this.demounting.nomName = null
      }
    },
    onSetServiceObject: function (serviceObject) {
      if (serviceObject) {
        this.demounting.serviceObjectKey = serviceObject.id
        this.demounting.serviceObjectName = serviceObject.name
      } else {
        this.demounting.serviceObjectKey = null
        this.demounting.serviceObjectName = null
      }
    },
    onSetBrigade: function (brigadeId) {
      if (brigadeId) {
        const brigadeName = this.brigades.find(item => item.brigadeId == brigadeId).brigadeName
        this.demounting.brigadeId = brigadeId
        this.demounting.brigadeName = brigadeName
      } else {
        this.demounting.brigadeId = null
        this.demounting.brigadeName = null
      }
    },
    onSetStock: function (stockKey) {
      if (stockKey) {
        const stockName = this.stocksOptions.find(item => item.stockKey == stockKey).stockName
        this.demounting.stockName = stockName
        this.demounting.stockKey = stockKey
      } else {
        this.demounting.stockName = null
        this.demounting.stockKey = null
      }
    },
    onSaveDemounting: function () {
      this.$emit('save', this.demounting)
      this.resetDemounting()
    },
    onCloseDemounting: function () {
      this.$emit('close')
      this.resetDemounting()
    },
    resetDemounting: function () {
      this.demounting.toolKey = null
      this.demounting.toolName = null
      this.demounting.serviceObjectName = null
      this.demounting.serviceObjectKey = null
      this.demounting.amount = null
      this.demounting.unit = null
      this.demounting.recId = null
      this.demounting.sn = null
      this.demounting.tag = null
      this.demounting.reportPaths = null
      this.demounting.reports = null
      this.demounting.time = null
      this.editedMaterial = null
      this.editedNomenclature = null
    },
    prepareStocks: function () {
      const brigadeStocks = []
      for (let i = 0; i < this.materialesAvailable.length; i++) {
        if (this.materialesAvailable[i].stockKey && this.materialesAvailable[i].stockKey.length) {
          for (let j = 0; j < this.materialesAvailable[i].stockKey.length; j++) {
            if (!brigadeStocks.map(stock => stock.stockKey).includes(this.materialesAvailable[i].stockKey[j])) {
              brigadeStocks.push({
                stockKey: this.materialesAvailable[i].stockKey[j],
                stockName: this.materialesAvailable[i].stockName[j],
                isBrigadeStock: true
              })
            }
          }
        }
      }

      let otherStocks = []
      if (!this.reportRoles.isContractor) {
        otherStocks = this.stocks.filter(stock => !brigadeStocks.map(stock => stock.stockKey).includes(stock.stockKey))

        this.stocksOptions = [
          ...brigadeStocks,
          ...otherStocks
        ]
      } else {
        // для подрядчиков демонтаж только на их склады
        this.stocksOptions = brigadeStocks
      }

      if (brigadeStocks.length) {
        this.defaultStockKey = brigadeStocks[0].stockKey
        this.defaultStockName = brigadeStocks[0].stockName
      }
    },
    getServiceObjects: function (text = '') {
      const urlName = '/service/delta/fastsearch/searchByTypeAndNameStart?type=serviceObject&limit=50&name=' + text
      return axiosGet({
        url: urlName,
        onSuccess: (response) => {
          return (response.data && response.data.length) ? response.data : []
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message ? response.message : 'Ошибка получения объектов обслуживания',
            progress: true,
            timeout: 10000
          })
          return Promise.reject(Error('Ошибка получения объектов обслуживания'))
        }
      })
    }
  }
}

